import axios from 'axios';
import { baseUrl, HttpMethods } from '../../../../base';
import type {
  IGetProjectTeamMembersService,
  IGetProjectTeamMembersServiceRes,
  IPatchRemoveProjectTeamMemberService,
  IPostProjectTeamMemberService,
} from './types';

export async function getProjectTeamMembers({
  projectId,
  params,
}: IGetProjectTeamMembersService): Promise<IGetProjectTeamMembersServiceRes> {
  const res = await axios.request<IGetProjectTeamMembersServiceRes>({
    method: HttpMethods.GET,
    url: `${baseUrl.SHERPA}/projects/${projectId}/team`,
    params,
  });
  return res.data;
}

export async function postProjectTeamMember({ projectId, data }: IPostProjectTeamMemberService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/projects/${projectId}/team`,
    data,
  });
  return res.data;
}

export async function patchRemoveProjectTeamMember({ projectId, memberId, data }: IPatchRemoveProjectTeamMemberService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.SHERPA}/projects/${projectId}/team/delete/${memberId}`,
    data,
  });
  return res.data;
}
